import styled from '@emotion/styled';
import {
  Z_INDEX_MAP,
  Z_INDEX_NAV_KEY,
  Z_INDEX_NAV_OVERLAY_KEY,
} from 'components/publicWebsiteV2/util/zIndexConstants';
import { COLORS_BACKGROUND, COLORS_TEXT } from '@zola/zola-ui/src/styles/emotion/colors';
import { CloseIcon } from '@zola/zola-ui/src/components/SvgIcons';
import { MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import HeaderCart from '../HeaderCart';

export const Container = styled.div`
  ${MEDIA_QUERY.DESKTOP} {
    display: none;
  }
`;

export const MobileHeaderContainer = styled.div`
  position: relative;
`;

export const MobileHeaderContent = styled.div<{
  pageType?: string;
}>`
  z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_KEY]};
  right: 0;
  padding-top: ${SPACING.S32};
  padding-right: ${SPACING.SM};
  padding-bottom: ${SPACING.XS};
  display: flex;
  flex-direction: row-reverse;
  ${({ pageType }) =>
    // pageType only undefined on home; Absolute so that it overlays hero image
    pageType === undefined && `position: absolute;`}
`;

export const StyledHeaderCart = styled(HeaderCart)`
  margin-right: 12px;
`;

export const FullScreenNavMenu = styled.div<{ opened: boolean }>`
  background-color: white;
  width: 70vw;
  height: 100vh;
  text-align: left;
  padding: 2rem;
  position: fixed;
  top: 0;
  right: 0;
  padding: 50px 40px;
  color: ${COLORS_TEXT.PRIMARY};
  font-weight: 600;
  line-height: 1.5;
  z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_OVERLAY_KEY]};
  overflow-y: auto;

  transform: translate3d(70vw, 0, 0);
  transition: transform 0.25s;
  ${({ opened }) => opened && `transform: translate3d(0vw, 0, 0);`}
`;

export const Overlay = styled.div<{ opened: boolean }>`
  display: ${({ opened }) => (opened ? 'block' : 'none')};
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: ${Z_INDEX_MAP[Z_INDEX_NAV_OVERLAY_KEY] - 1};
  &:hover {
    cursor: pointer;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  right: 20px;
  top: 20px;
  fill: ${COLORS_TEXT.BODY};
  &:hover {
    cursor: pointer;
  }
`;

export const NavItem = styled.a`
  font-size: 24px;
`;

export const MobileNavLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  a {
    color: inherit;
    margin-bottom: 10px;
    &:hover {
      text-decoration: none;
    }
  }

  padding-top: 25px;
  border-top: 1px solid ${COLORS_BACKGROUND.OUTLINE_GRAY};
  margin-top: 25px;
`;

export const WeddingDetailsText = styled.div`
  color: ${COLORS_TEXT.SECONDARY};
  font-weight: 400;
`;
